import { render, staticRenderFns } from "./info.html?vue&type=template&id=458823c3&scoped=true&"
import script from "./info.js?vue&type=script&lang=js&"
export * from "./info.js?vue&type=script&lang=js&"
import style0 from "./info.scss?vue&type=style&index=0&id=458823c3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458823c3",
  null
  
)

export default component.exports